module.exports = __webpack_public_path__ + "static/img/Roland-Garros-Stadium.01c069b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Roland-Garros-Stadium.jpg
// module id = mV30
// module chunks = 0